import { createFileRoute } from '@tanstack/react-router';
import { DataImportListPage } from '@/pages/data-imports/ui/DataImportListPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';

/**
 * データインポート一覧ルート
 *
 * 検索パラメータ:
 * - fiscal_year: 事業年度でフィルタ
 * - data_type: データ区分でフィルタ
 * - page: ページ番号
 * - page_size: ページサイズ
 */
export const Route = createFileRoute('/_protected/data-import/')({
  component: DataImportListPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      defaultValues: undefined,
    }),
});
